import { chatConstants } from '../constants';

const initialState = {
    loading: false,
    chatmessages: [],
    requestedClassID: null,
    fetchedClassID: null,
    error: null
};

const chatReducer = (state = initialState, action) => {
    switch (action.type) {
        case chatConstants.FETCH_CHATMESSAGES_REQUEST:
            return {
                ...state,
                loading: true,
                requestedClassID: action.classId,
                error: null
            };
        case chatConstants.FETCH_CHATMESSAGES_SUCCESS:
            if (state.requestedClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                loading: false,
                chatmessages: action.chatmessages,
                requestedClassID: action.classId,
                fetchedClassID: action.classId,
                error: null
            };
        case chatConstants.FETCH_CHATMESSAGES_FAILURE:
            if (state.requestedClassID !== action.classId) {
                return state;
            }

            return {
                ...state,
                loading: false,
                requestedClassID: action.classId,
                error: action.error
            };
        case chatConstants.SEND_CHATMESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case chatConstants.SEND_CHATMESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                chatmessages: action.chatmessages,
            };
        case chatConstants.SEND_CHATMESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case chatConstants.UPDATE_CHATMESSAGES:
            return {
                ...state,
                chatmessages: action.chatmessages
            };
        case chatConstants.HYDRATE_CHATMESSAGES:
            return {
                ...state,
                loading: false,
                chatmessages: action.chatmessages,
                requestedClassID: action.classId,
                fetchedClassID: action.classId,
                error: null
            };
        case chatConstants.RESET_CHATMESSAGES:
            return {
                ...state,
                loading: false,
                chatmessages: [],
                requestedClassID: null,
                fetchedClassID: null,
                error: null
            };
        default:
            return state;
    }
};

export default chatReducer;
